export default function( d, initiator, url ){
	
	d.map((entry) => {

		if( entry.action ){

			document.dispatchEvent(
				new CustomEvent(
					entry.action,
					{ detail: {
						payload: entry.payload,
						initiator: initiator,
						url: url
					} }
				)
			);

		} else {
			console.warn( `Unrecognized response entry: ${JSON.stringify(entry)}` );
		}

	} );


}